export class Product {
    id!: string;
    name!: string;
    productId!: string;
    productTemplate!: string;
  }
  